var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7503 8.33333H17.7087V7.29167C17.7087 4.41979 15.3722 2.08333 12.5003 2.08333C9.62845 2.08333 7.29199 4.41979 7.29199 7.29167V8.33333H6.25033C5.69779 8.33333 5.16789 8.55283 4.77719 8.94353C4.38649 9.33423 4.16699 9.86413 4.16699 10.4167V20.8333C4.16699 21.3859 4.38649 21.9158 4.77719 22.3065C5.16789 22.6972 5.69779 22.9167 6.25033 22.9167H18.7503C19.3029 22.9167 19.8328 22.6972 20.2235 22.3065C20.6142 21.9158 20.8337 21.3859 20.8337 20.8333V10.4167C20.8337 9.86413 20.6142 9.33423 20.2235 8.94353C19.8328 8.55283 19.3029 8.33333 18.7503 8.33333ZM9.37533 7.29167C9.37533 5.56875 10.7774 4.16667 12.5003 4.16667C14.2232 4.16667 15.6253 5.56875 15.6253 7.29167V8.33333H9.37533V7.29167ZM13.542 16.3781V18.75H11.4587V16.3781C10.8389 16.0177 10.417 15.3531 10.417 14.5833C10.417 14.0308 10.6365 13.5009 11.0272 13.1102C11.4179 12.7195 11.9478 12.5 12.5003 12.5C13.0529 12.5 13.5828 12.7195 13.9735 13.1102C14.3642 13.5009 14.5837 14.0308 14.5837 14.5833C14.5837 15.3521 14.1618 16.0167 13.542 16.3781Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternal);
export default __webpack_public_path__ + "static/media/Internal.4f0699fc486438f33b561937d9a382df.svg";
export { ForwardRef as ReactComponent };